import { captureException } from "@sentry/react";

import { isUnauthorizedResponse } from "./sdk-errors";

/**
 * Reports a read the caller has already classified as failed. Unlike `reportAsyncError`, it
 * captures errors that carry an HTTP status too: the caller has ruled out the statuses it
 * handles (a denial, a missing item), so whatever reaches here is a failure worth seeing.
 * The exception is a 401: the auth layer already clears the session and reloads the page on
 * it, so a report would only record the reload. In dev, mirrors to `console.error` so
 * failures surface during local work.
 */
export function reportReadFailure(
  label: string,
  error: unknown,
  context?: Record<string, unknown>,
  options?: { tags?: Record<string, string> },
): void {
  if (isUnauthorizedResponse(error)) return;

  if (import.meta.env.DEV) {
    console.error(`[read-failure:${label}]`, error, context);
  }

  captureException(error, { tags: options?.tags, extra: { label, ...context } });
}
